import { CodeTypeE } from 'primsell-shared-layer/types'

export const TableCampaignNameTypeConfig: Record<CodeTypeE, string> = {
  [CodeTypeE.QR_CODE]: 'Events',
  [CodeTypeE.REDEEM_CODE]: 'NFT redemption',
  [CodeTypeE.LOYALTY]: 'Loyalty',
}
